module.exports = __webpack_public_path__ + "img/1396317916.d9f96e7d.jpg";